import type { DriveStep } from 'driver.js';

export const PAYMENT_MODAL_TOUR_KEY = 'modal-payment';

export const paymentModalTour: DriveStep[] = [
  {
    element: '[data-tour="modal-payment-summary"]',
    popover: {
      title: 'Amount due',
      description:
        'The reference, context, and total due appear here. Tips and service charges are included in the total shown.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-tour="modal-payment-methods"]',
    popover: {
      title: 'Payment method',
      description:
        'Choose M-Pesa, cash, card, or split. Available methods depend on your property configuration in the Super Admin Console.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-tour="modal-payment-fields"]',
    popover: {
      title: 'Method details',
      description:
        'Enter the phone number, cash received, card number, or split amounts required for the selected method. Optional tip adjusts the total.',
      side: 'top',
      align: 'start',
    },
  },
  {
    element: '[data-tour="modal-payment-actions"]',
    popover: {
      title: 'Review and confirm',
      description:
        'Click Review Receipt to verify line items, then Confirm Payment to submit to the fiscal engine. Pending M-Pesa payments can be refreshed from the status step.',
      side: 'top',
      align: 'end',
    },
  },
];
